const environment = process.env.REACT_APP_ENV;
//console.log('Environment:', process.env);

export const API_URL = (() => {
  switch (environment) {
    case "prod":
      return "https://ninds.cde-editor.com/cdeService/";
    case "test":
      return "https://dev-ninds.cde-editor.com/cdeService/";
    default:
      return "http://localhost:8080/";
  }
})();

export const API_CONFIG = {
  headers: {
    platform: "ninds"
  }
};
